import { useEffect } from 'react';

import type { RecommendChatSettings } from '@app/api/RecommendChat';

interface UseLoyaltyChatSettingsModalEffectsParams {
  settings: RecommendChatSettings | undefined;
  onInitialize(settings: RecommendChatSettings): void;
}

export const useLoyaltyChatSettingsModalEffects = ({
  settings,
  onInitialize,
}: UseLoyaltyChatSettingsModalEffectsParams) => {
  useEffect(() => {
    if (settings) onInitialize(settings);
  }, [onInitialize, settings]);
};
